import { useLocation, useSearchParams } from 'react-router-dom';

import { INSTANCE_ID_QUERY_PARAM_KEY, LOCAL_STORAGE_INSTANCE_ID_KEY } from '@frontend/utils/misc';

import { useLocalstorageParam } from './useLocalstorageParam';

const useInstanceId = () => {
  const [localInstanceId, setLocalInstanceId] = useLocalstorageParam(LOCAL_STORAGE_INSTANCE_ID_KEY);
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const instanceIdInQuery = searchParams.get(INSTANCE_ID_QUERY_PARAM_KEY);
  const locationParts = location.pathname.split('/');
  const instanceIdInPath =
    locationParts.length > 2 && locationParts[1] === 'instances' ? locationParts[2] : null;

  const instanceIdInUrl = instanceIdInQuery || instanceIdInPath;

  const instanceIdToUse = instanceIdInUrl || localInstanceId;

  if (instanceIdInUrl && localInstanceId !== instanceIdInUrl) {
    setLocalInstanceId(instanceIdInUrl);
  }

  return { instanceId: instanceIdToUse };
};

export { useInstanceId };
